// query parameters that affect page content for SEO purposes
export const CANONICAL_PARAMS = new Set([
  'limit', // https://schoolhouse.world/explore/tutors?limit=48
  'pastLimit', // https://schoolhouse.world/u/1?show=sessions&pastLimit=12
  'page', // https://schoolhouse.world/certification/get-certified?page=1
  'sessionsLimit', // https://schoolhouse.world/explore/all?sessionsLimit=48
  'show', // https://schoolhouse.world/leaderboard?show=month
  'step', // https://schoolhouse.world/topic/67/certify?step=2

  // Content changes slightly for the following, but not enough for different canonicals
  // 'course', // https://schoolhouse.world/explore/tutors?course=pre-calculus
  // 'date', // https://schoolhouse.world/live-help?date=mondayfeb21
  // 'pastSessions', // https://schoolhouse.world/series/578?pastSessions=true
  // 'search', // https://schoolhouse.world/explore/tutors?search=test
  // 'sort', // https://schoolhouse.world/explore/tutors?sort=mostfollowed
  // 'topics', // https://schoolhouse.world/course/algebra?topics=93
])

export const SESSION_SEARCH_QUERY_PARAM = 'ssearch'
